export const environment = {
  production: false,
  apiBaseUrl: 'https://api.prod.bikaji.distiz.com/api',
  apiversion: 1.0,
  reportApiBaseUrl: 'https://dmsqa.bikaji.com/api'
};